(() => {
  'use strict';
  if (window.DACVotesImageGestures) return;
  const bound = new WeakSet();
  const controls = 'a,button,input,select,textarea,[role="button"],[data-vp-modal-navigation],[data-vp-modal-image-vote]';
  function bind({ surface, dialog, isOpen, close, signal, resetOn }) {
    if (!surface || !dialog || bound.has(surface) || signal?.aborted) return;
    bound.add(surface);
    let gesture = null, timer = null;
    const zoomed = event => (window.visualViewport?.scale || 1) > 1.01 || (event.scale != null && Math.abs(event.scale - 1) > .01);
    const clearMotion = () => {
      clearTimeout(timer);
      dialog.classList.remove('dac-votes-image-dragging', 'dac-votes-image-returning');
      dialog.style.removeProperty('--dac-votes-drag');
    };
    const reset = () => { gesture = null; clearMotion(); };
    const scrolled = () => {
      for (let node = surface; node; node = node.parentElement) {
        if (node.scrollTop > 0) return true;
        if (node === dialog) break;
      }
      return false;
    };
    function start(event) {
      if (!isOpen() || event.target.closest(controls)) return;
      if (gesture || event.touches.length !== 1 || zoomed(event) || scrolled()) {
        clearMotion(); gesture = { blocked: true }; return;
      }
      clearMotion();
      const touch = event.touches[0];
      gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, axis: null, dragged: false };
    }
    function move(event) {
      if (!gesture) return;
      if (!isOpen()) { reset(); return; }
      if (event.touches.length !== 1 || zoomed(event)) { clearMotion(); gesture.blocked = true; return; }
      if (gesture.blocked) return;
      const touch = Array.from(event.touches).find(t => t.identifier === gesture.id);
      if (!touch) { reset(); return; }
      const dx = touch.clientX - gesture.x, dy = touch.clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
        if (Math.abs(dx) > Math.abs(dy) * 1.25) gesture.axis = 'horizontal';
        else if (Math.abs(dy) > Math.abs(dx) * 1.25) gesture.axis = dy > 0 ? 'down' : 'up';
      }
      if (gesture.axis !== 'down') return;
      if (event.cancelable) event.preventDefault();
      gesture.dragged = true;
      dialog.classList.add('dac-votes-image-dragging');
      dialog.style.setProperty('--dac-votes-drag', Math.min(220, Math.max(0, dy) * .8) + 'px');
    }
    function end(event) {
      if (!gesture) return;
      if (event.touches.length) {
        clearMotion(); gesture.blocked = true; event.stopImmediatePropagation(); return;
      }
      const current = gesture; gesture = null;
      if (!isOpen()) { clearMotion(); return; }
      if (current.blocked || zoomed(event)) {
        event.stopImmediatePropagation(); clearMotion(); return;
      }
      if (current.axis !== 'down' && current.axis !== 'up') { clearMotion(); return; }
      event.stopImmediatePropagation();
      if (current.axis === 'up') { clearMotion(); return; }
      if (event.cancelable) event.preventDefault();
      const touch = Array.from(event.changedTouches).find(t => t.identifier === current.id);
      const dx = touch ? touch.clientX - current.x : 0, dy = touch ? touch.clientY - current.y : 0;
      if (dy >= 80 && dy > Math.abs(dx) * 1.25) { clearMotion(); close(); return; }
      if (!current.dragged) { clearMotion(); return; }
      dialog.classList.remove('dac-votes-image-dragging');
      dialog.classList.add('dac-votes-image-returning');
      dialog.style.removeProperty('--dac-votes-drag');
      timer = setTimeout(clearMotion, 180);
    }
    const options = { capture: true, passive: true };
    surface.addEventListener('touchstart', start, options);
    surface.addEventListener('touchmove', move, { capture: true, passive: false });
    surface.addEventListener('touchend', end, { capture: true, passive: false });
    surface.addEventListener('touchcancel', reset, options);
    resetOn?.addEventListener('navigate', reset);
    signal?.addEventListener('abort', () => {
      reset(); bound.delete(surface);
      surface.removeEventListener('touchstart', start, true);
      surface.removeEventListener('touchmove', move, true);
      surface.removeEventListener('touchend', end, true);
      surface.removeEventListener('touchcancel', reset, true);
      resetOn?.removeEventListener('navigate', reset);
    }, { once: true });
  }
  window.DACVotesImageGestures = { bind };
})();
